import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [FlexLayoutModule, MatIcon, TranslatePipe, MatButtonModule, MatProgressSpinner],
  selector: 'iot-platform-ui-download-card',
  templateUrl: './download-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./download-card.component.scss']
})
export class DownloadCardComponent {
  loading = input<boolean>(false);
  cardText = input<string>('');
  buttonText = input<string>('');
  isVisible = input<boolean>(false);

  download = output<void>();
}
